module.exports = __webpack_public_path__ + "static/media/FIVE.f83de39b.png";